
<main class="the_main">


    <!-- PIPELINE LICENSE RENEWAL(VIEW TASK)=================================PIPELINE LICENSE RENEWAL (VIEW TASK) =======================================PIPELINE LICENSE RENEWAL(VIEW TASK)======================= -->

    <div class="view_task">


      <!-- stage list tree=====================stage list tree======================stage list view======= -->

      <div class="stage_list-tree">

        <h2 class="percentage"> {{getTemplate().PipelineTemplateName}}<span class="category_select" [matMenuTriggerFor]="menu" >{{getCategory()}} Category<em class="ti-angle-down"></em> </span></h2>

        <mat-menu #menu="matMenu"  >
          <button
            mat-menu-item
            *ngFor="let plcategory of stagecategories"
            (click)="selectCategory(plcategory.id)"
          >

            <span>{{ plcategory.PipelineLicenseCategoryName }}</span>
          </button>
        </mat-menu>
        <div class="stage_scroll">


          <!-- active -->
          <div class="step active" *ngFor="let stage of filteredstagies" >
            <div class="v-stepper" >
              <div class="circle"></div>
              <div class="line"></div>
            </div>
            <div class="centralize" >
              <div class="content"  >
                <h2 class="stage_name"  (click)="selectStage(stage.id)">{{stage.PipelineLicenseStageName}}  &nbsp;
                  
                  <!-- <button mat-mini-fab title="Add New Task" style="width: 25px; height: 25px;" (click)="createTask(stage); $event.stopImmediatePropagation()"><mat-icon style="font-size: 15px; margin-bottom: 30px;">add</mat-icon></button> -->
                  <em class="ti-more-alt" (click)="$event.stopImmediatePropagation()"  [matMenuTriggerFor]="mtx"></em> 
                  <mat-menu #mtx="matMenu"   >
                    <button mat-menu-item (click)="createTask(stage); $event.stopImmediatePropagation()">
                      <span>Add mew task</span>
                    </button>

                    <button mat-menu-item (click)="deleteStage(stage.id); $event.stopImmediatePropagation()" *ngIf="!checkStage(stage.id)">
                      <span>Delete Stage</span>
                    </button>
                  </mat-menu>
                </h2>

                <ul class="task_list" >
                  <li class="task" *ngFor="let activity of filterActivity(stage.id)"  (click)="selectTask(activity)">{{activity.Name}}  </li>  
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>




      <!-- view stage info================================view stage info===============view stage info -->

  <div *ngIf="!newStage" >
      <div class="stage_info" >
        <div class="top">
          <h2 class="title" *ngIf="stage">
            <span class="pipeline_name">License renewal</span> -
            <span class="the_stage">{{stage.PipelineLicenseStageName}}</span>
          </h2>
          <button class="default_secondary-btn" (click)="createStage()">Create New Stage</button>
          <button class="default_secondary-btn" (click)="backToTemplate()">Back To Template</button>
        </div>
  <!-- Stage Card=================================Stage card=======================================stage card======================= -->


          <div class="centralize" *ngIf="stage">
            <div class="stage_card"  >
              <div class="task_list">
                <h2 class="title">Task</h2>


                <p class="task" *ngFor="let factivity of filterActivity(stage.id)" (click)="selectActivity(factivity.id)">
                  <em class="ti-pin-alt"></em> 
                  <span class="name">{{factivity.Name}}</span>
                  <em class="ti-more-alt" [matMenuTriggerFor]="actmenu"></em> 
                  <mat-menu #actmenu="matMenu"   >
                    <button mat-menu-item *ngIf="!checkActivity(factivity.id)" (click)="DeleteActivity(factivity.id, stage.id)">
                      <span>Delete Activity</span>
                    </button>

                    <button mat-menu-item   (click)="editActivity(factivity); $event.stopImmediatePropagation">
                      <span>Edit activity</span>
                    </button>
                  </mat-menu>
                </p>

              </div>

              <div class="task_info" *ngIf="activity" >
                <p class="top">
                  <span>{{activity.Name}}</span>
                  <span>{{activity.EstimatedDuration}} days duration</span>
                </p>


                <div class="center">
                  <div class="main_task-info">
                    <div class="the_header" >
                      <p>Stakeholder Matrix <span class="counter">{{filterPixStakeholderMatrix(activity.id).length}}</span> </p>
                      <p>RACI</p>
                    </div>

                    <div class="task_entered" *ngFor="let matrix of filterPixStakeholderMatrix(activity.id)" >
                      <span class="stakeholder" *ngIf="getStakeholderName(matrix)" >{{getStakeholderName(matrix).PipelineLicenseStakeholderName}}</span>
                      <span class="raci" *ngIf="getRaci(matrix)" >{{getRaci(matrix).Abbreviation}}</span>
                      <em class="ti-more-alt"  [matMenuTriggerFor]="mtx"></em> 
                      <mat-menu #mtx="matMenu"   >
                        <button mat-menu-item *ngIf="!checkMatrix(matrix.id)" (click)="DeleteMatrix(matrix.id,stage.id)">
                          <span>Delete Matrix</span>
                        </button>

                        <button mat-menu-item *ngIf="getRaci(matrix)"  (click)="DeleteMatrixRaci(checkMatrix(matrix.id).id, stage.id)">
                          <span>Delete Raci</span>
                        </button>
                      </mat-menu>
                    </div>

                  </div>
                </div>

              </div>

            </div>
          </div>

  </div>

  <!-- Stage Card=================================Stage card=======================================stage card======================= -->


      </div>

      <!-- PIPELINE LICENSE RENEWAL(CREATE STAGE)=================================PIPELINE LICENSE RENEWAL (CREATE STAGE) =======================================PIPELINE LICENSE RENEWAL(CREATE STAGE)======================= -->

      <div class="create_new-stage" *ngIf="newStage" >
      <cradua-add-pl-stage-activity 
      [stages]="stages"
      [templateId]="templateId"
      [racies]="racies"
      [selectedCategory]="selectedCategory"
      [stakeholders]="stakeholders"
      [identityusers]="identityusers"
      [actionpersons]="actionpersons"
      [plstageactivities]="plstageactivities"
      [plstakeholdersmatrix]="plstakeholdersmatrix"
      [plstakeholdersmatrixraci]="plstakeholdersmatrixraci"
      (deleteActivityEvent)="onDeleteActivityEvent($event)"
      (submiteventemitter)="onSubmitActivity($event)"
      (deleteMatrixEvent)="onDeleteMatrixEvent($event)"
      (deleteRaciEvent)="onDeleteRaciEvent($event)"
      (backEvent)="backToTemplate($event)"
      ></cradua-add-pl-stage-activity>


      </div>

    </div>

  </main>
